/* eslint-disable react/jsx-no-bind */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Loading from '../common/Loading.js';
import ErrorMessage from '../common/ErrorMessage.js';
import ArtistService from '../../services/artistService';
import ToastrService from '../../services/toastrService';
import { Redirect } from 'react-router-dom';
import MaterialDropDown from '../common/MaterialDropDown.js';
import MaterialInput from '../common/MaterialInput.js';
import swal from 'sweetalert';

class EditWatchMe extends React.Component {
    constructor(props, context) {
        super(props, context);      
        this.initialise = this.initialise.bind(this);
        this.editVideo = this.editVideo.bind(this);
        this.removeVideo = this.removeVideo.bind(this);
        this.addVideo = this.addVideo.bind(this);
        this.showAdd = this.showAdd.bind(this);
        this.closeShowAdd = this.closeShowAdd.bind(this);
        this.updateVideo = this.updateVideo.bind(this);   
        this.closeEditVideo = this.closeEditVideo.bind(this);
        this.updateSelectedVideoField = this.updateSelectedVideoField.bind(this);
        this.updateNewVideoField = this.updateNewVideoField.bind(this);
        this.showNeedVideo = this.showNeedVideo.bind(this);
        this.videoSources = ['YouTube', 'Vimeo'];
        this.state = {
            profile: this.props.profile,
            videos: [],
            loadingVideos: false,
            showAdd: false,
            uploadingVideo: false,
            selectedVideo: null,
            newVideo: {}
        };
     }

    componentWillMount() {
        this.initialise();
    }

    componentDidMount() {  
    }

    componentWillUpdate(nextProps, nextState) {
        if(nextProps.profile.ID !== this.props.profile.ID) {
            this.setState({
                profile: nextProps.profile,
                videos: [],
                selectedVideo: null
            }, this.initialise);
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if((this.state.selectedVideo && !prevState.selectedVideo) || (this.state.showAdd && !prevState.showAdd)) {
            window.componentHandler.upgradeDom();  
        }    
    }

    initialise(clearProfileVideos = false) {
        this.setState({ loadingVideos: true, selectedVideo: null, error: null });
        this.props.actions.getVideos(this.state.profile.ID)
            .then(videos => {
                this.setState({ loadingVideos: false, videos });
                if(clearProfileVideos) {
                    this.props.actions.clearProfileVideos(this.state.profile.ID);
                }
            })
            .catch(error => this.setState({ loadingVideos: false }));
    }

    editVideo(event, video) {
        event.preventDefault();
        this.setState({ selectedVideo: video, error: null, uploadError: null });
    }

    closeEditVideo(event) {
        event.preventDefault();
        this.initialise();
    }

    removeVideo(event, video) {
        event.preventDefault();
        if(confirm(`Remove video '${video.Name}' from your LoudUp page? This will delete any video ratings and play stats`)) {
            this.props.actions.deleteVideo(this.state.profile.ID, video.ID)
                .then(_ => {
                   this.initialise(true);
                   const toastrService = new ToastrService();
                    toastrService.showSuccess('', 'The video has been removed successfully');
                })
                .catch(error => {
                    this.setState({ error: 'Sorry, something went wrong, unable to delete video' });
                });
        }
        else {
            return false;
        }
    }

    addVideo(event) {    
        event.preventDefault();
        if(this.state.newVideo.Path) {
            this.setState({ error: null });
            this.props.actions.addVideo(this.state.profile.ID, this.state.newVideo)
                .then(video => {
                    const videos = [...this.state.videos].concat(video);   
                    this.setState({ videos, newVideo: { }, showAdd: false });
                    this.props.actions.clearProfileVideos(this.state.profile.ID);
                })
                .catch(error => {
                    this.setState({ error: error.message });
                });
        }
        else {
            this.setState({error: 'Please select a video to add'});
        }
        
    }

    showAdd(event) {
        event.preventDefault();
        this.setState({ showAdd: true });
    }

    closeShowAdd(event) {
        event.preventDefault();
        this.setState({ showAdd: false, newVideo: { }, error: null });
    }

    updateVideo(event) {
        event.preventDefault();
        const video = this.state.selectedVideo;
        this.props.actions.updateVideo(this.state.profile.ID, video.ID, video)
            .then(updatedVideo => {
                const toastrService = new ToastrService();
                toastrService.showSuccess('', 'The changes have been saved successfully');
                this.initialise(true);
            }) 
            .catch(error => {
                this.setState({ error: error.message });
            });
    }

    updateSelectedVideoField(event) {
        const name = event.target.name || event.target.attributes['name'].value;
        let value;
        if(event.target.className === 'mdl-checkbox__input') {
            value = event.target.checked;
        }
        else if (event.target.className === 'mdl-menu__item') {
            value = event.target.innerText;
        }  
        else {
            value = event.target.value;
        }
        const selectedVideo = {...this.state.selectedVideo};
        selectedVideo[name] = value;
        this.setState({ selectedVideo });
    }

    updateNewVideoField(event) {
        const name = event.target.name || event.target.attributes['name'].value;
        let value;
        if(event.target.className === 'mdl-checkbox__input') {
            value = event.target.checked;
        }
        else if (event.target.className === 'mdl-menu__item') {
            value = event.target.innerText;
        }  
        else {
            value = event.target.value;
        }
        const newVideo = {...this.state.newVideo};
        newVideo[name] = value;
        this.setState({ newVideo });
    }

    showNeedVideo(event) {
        event.preventDefault();
        swal({
            title: 'Need a video?',
            content: {
                element: 'div',
                attributes: {
                    innerHTML: '<p>Get a custom <a href="/go/fiverr-profile-video" target="_blank">music video</a> which you can upload to your profile and use on YouTube and your social profiles'
                }
            },
            button: 'Ok, got it!'
        });
    }

    render() {
        return (
            this.props.profile.RoleType === 'Fan' || !ArtistService.showVideos(this.props.profile.RoleType) ?
                <Redirect to="/Profile/Manage" />
                :
                !this.state.selectedVideo ? 
                    <div id="divCreateProfile">                        
                        {
                            this.state.showAdd ?                                
                                <form id="frmAddVideo" className="form-tightfields form-regular" onSubmit={this.addVideo}>                                    
                                    <a href="#" style={{float:'right'}} onClick={this.closeShowAdd}>Close</a>
                                     <p style={{ paddingBottom: '15px' }}>
                                        Please enter the YouTube or Vimeo url for the video and then click on 'Add'
                                    </p>  
                                    <ErrorMessage error={this.state.error} onClose={() => this.setState({ error: null })} />
                                    <MaterialDropDown
                                        name="Source"
                                        className={`getmdl-select__fullwidth placeholder ${this.state.newVideo.Source ? 'is-dirty' : ''}`}
                                        title="Video Source"
                                        readOnly
                                        value={this.state.newVideo.Source}
                                        data={this.videoSources}
                                        onClick={this.updateNewVideoField} />
                                    <MaterialInput name="Path" type="url" title="Video Url" value={this.state.newVideo.Path} onChange={this.updateNewVideoField} maxLength="150" />
                                    <MaterialInput name="Name" value={this.state.newVideo.Name} onChange={this.updateNewVideoField} maxLength="35" />
                                    <MaterialInput name="Description" value={this.state.newVideo.Description} onChange={this.updateNewVideoField} maxLength="300" />
                                    <input type="submit" className="mdl-button mdl-js-button mdl-button--raised mdl-js-ripple-effect mdl-button--accent mdl-button--wide" value="ADD" onClick={this.addVideo} />                                  
                                </form>
                            : 
                                <React.Fragment>
                                    <p>You can upload up to 8 videos</p>
                                    <ErrorMessage error={this.state.error} onClose={() => this.setState({ error: null })} />
                                    <a id="aAddNewVideo" href="#" className="btn-simple transition" onClick={this.showAdd} style={{display: this.state.videos.length < 8 ? 'inline' : 'none'}}>Add new video →</a>                       
                                    <br />
                                    <br />
                                    <br />
                                    <a href="#" className="btn btn-primary btn-simple transition" style={{color: '#fff'}} onClick={this.showNeedVideo}><strong>Need a video?</strong></a>

                                    <div id="loudUpVideos">                        
                                        <p className="formlegend">Videos added to LoudUp</p>
                                        <div className="table-info visible-xs">&#8592; SCROLLABLE &#8594;</div>
                                        <div className="table-responsive">
                                            <table id="uploaded" className="table table-striped table-results gig-listings">
                                                <thead>
                                                    <tr>
                                                        <th>NAME</th>
                                                        <th>DESCRIPTION</th>
                                                        <th>SOURCE</th>
                                                        <th>FEATURED</th>
                                                        <th>UPLOADED</th>
                                                        <th>&nbsp;</th>
                                                        <th>&nbsp;</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {
                                                        this.state.videos.length ?
                                                            this.state.videos.map(video => 
                                                                <tr key={video.ID} className="transition">
                                                                    <td>
                                                                        {video.Name}
                                                                    </td>
                                                                    <td>
                                                                        {video.Description}
                                                                    </td>
                                                                    <td>
                                                                        {video.Source}
                                                                    </td>
                                                                    <td>
                                                                        <input type="checkbox" name="Featured" checked={video.Featured} disabled />
                                                                    </td>
                                                                    <td>{new Date(video.UploadDate).toLocaleDateString('en-GB', { year: 'numeric', month: 'short', day: 'numeric' })}</td>
                                                                    <td>
                                                                        <a href="#" className="btn-simple transition" onClick={(e) => this.editVideo(e, video)}>Edit</a>
                                                                    </td>
                                                                    <td>
                                                                        <a href="#" className="btn-simple transition" onClick={(e) => this.removeVideo(e, video)}>Remove</a>
                                                                    </td>
                                                                </tr>   
                                                            )                                            
                                                        : 
                                                        <tr>
                                                            <td colSpan="7" style={{textAlign: 'center'}}>
                                                                {
                                                                    this.state.loadingVideos ? 
                                                                        <Loading /> 
                                                                        : 'No videos have been added to your LoudUp page yet'
                                                                }
                                                            </td>
                                                        </tr>
                                                    }
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>                                   
                                </React.Fragment>
                        }                        
                    </div>   
                :            
                    <div id="editVideo" className="form form-block">
                        <a href="#" style={{float:'right'}} onClick={this.closeEditVideo}>Close</a>
                        <p style={{fontWeight: 'bold'}}>Edit Video Information</p>
                        <form id="frmEditVideo" className="form-tightfields form-regular" onSubmit={this.updateVideo}>
                            <ErrorMessage error={this.state.error} onClose={() => this.setState({ error: null })} />
                            <MaterialDropDown
                                name="Source"
                                label="Video Source"
                                readOnly 
                                value={this.state.selectedVideo.Source}
                                className={`getmdl-select__fullwidth placeholder ${this.state.selectedVideo.Source ? 'is-dirty' : ''}`}
                                data={this.videoSources}
                                onClick={this.updateSelectedVideoField} />
                            <MaterialInput name="Path" label="Video Url" value={this.state.selectedVideo.Path} onChange={this.updateSelectedVideoField} maxLength="150" />
                            <MaterialInput name="Name" value={this.state.selectedVideo.Name} onChange={this.updateSelectedVideoField} maxLength="35" />
                            <MaterialInput name="Description" value={this.state.selectedVideo.Description} onChange={this.updateSelectedVideoField} maxLength="300" />
                            { //check if this was the original featured video, if so, don't allow it to be deselected, we can only select a new featured video
                                !this.state.videos.find(i => i.ID === this.state.selectedVideo.ID).Featured ?
                                <label className="mdl-checkbox mdl-js-checkbox mdl-js-ripple-effect" htmlFor="Featured" style={{ paddingBottom: '25px' }}>
                                    <input type="checkbox" id="Featured" name="Featured" className="mdl-checkbox__input" checked={this.state.selectedVideo.Featured} onChange={this.updateSelectedVideoField} />
                                    <span className="mdl-checkbox__label">Set as featured video</span>
                                </label>
                                : null
                            }
                            <input type="submit" value="Save" className="mdl-button mdl-js-button mdl-button--raised mdl-js-ripple-effect mdl-button--accent mdl-button--wide" />                   
                        </form>
                    </div>                
        );
    }
}

EditWatchMe.propTypes = {
    profile: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired
};

export default EditWatchMe;